<template>
    <div>
        <h4 class="mb-3">
            <span class="text-muted">{{ $t('riepilogo') }}</span>
        </h4>
        <div class="bg-white border rounded small">
            <div class="d-flex justify-content-between p-3 border-bottom">
                <span class="text-muted">Ateneo</span>
                <span class="fw-bold text-secondary ps-3 text-truncate">{{ university }}</span>
            </div>
            <div class="d-flex justify-content-between p-3 border-bottom" v-if="from != 'PEGASOINTERNATIONAL'">
                <span class="text-muted">{{ $t('categoria') }}</span>
                <span class="fw-bold text-secondary ps-3 text-truncate">{{ category }}</span>
            </div>
            <div class="d-flex justify-content-between p-3 border-bottom" v-if="category != 'Esami Singoli'">
                <span class="text-muted">{{ $t('corso') }}</span>
                <span class="fw-bold text-secondary ps-3 text-truncate">{{ course }}</span>
            </div>
            <div class="d-flex justify-content-between p-3 border-bottom">
                <span class="text-muted">{{ ecp_text }}</span>
                <div v-if="ecp">
                    <span class="fw-bold text-secondary ps-3 text-truncate">{{ ecp }}</span>
                </div> 
                <div v-else>
                    <span><i class="fas fa-circle-notch fa-spin"></i></span>
                </div>
            </div>
            <div class="d-flex justify-content-between p-3 border-bottom" v-if="showConvention">
                <span class="text-muted">{{ $t('convenzione') }}</span>
                <div v-if="convention">
                    <span class="fw-bold text-secondary ps-3 text-truncate">{{ convention }}</span>
                </div> 
                <div v-else>
                    <span><i class="fas fa-circle-notch fa-spin"></i></span>
                </div>
            </div>
            <div class="d-flex justify-content-between p-3 border-bottom" v-if="showProgram">
                <span class="text-muted">{{ $t('programma') }}</span>
                <span class="fw-bold text-uppercase text-secondary ps-3 text-truncate">{{ program }}</span>
            </div>
            <div class="d-flex justify-content-between p-3 border-bottom" v-if="showInstallments">
                <span class="text-muted">{{ $t('rate') }}</span>
                <span class="fw-bold text-secondary">{{ rate }}</span>
            </div>
            <div class="d-flex justify-content-between p-3">
                <span class="text-muted">{{ $t('importo') }}</span>
                <h5 class="fw-bold my-0" v-if="mp_tot">€ {{ mp_tot }}</h5>
            </div>
            <div class="bg-light rounded text-secondary mx-3 mb-3 p-3" v-if="installments && category != 'Esami Singoli'">
                <p><strong><i class="fas fa-list-alt me-2"></i>{{ $t('prospetto_primo_anno') }}</strong></p>
                <table class="table table-bordered table-sm text-secondary mb-0">
                    <thead>
                        <tr class="border-bottom">
                            <th>{{ $t('scadenza') }}</th>
                            <th class="text-center">{{ $t('importo') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(installment, index) in installments" :key="index" class="border-bottom"> 
                            <td>{{ installment.date }}</td> 
                            <td class="text-center" v-if="index == 0 && Number(installment.tax) > 0"><strong>€ {{ Number(installment.import) + Number(installment.tax) }}*</strong></td>
                            <td class="text-center" v-else><strong>€ {{ installment.import }}</strong></td>
                        </tr>
                    </tbody>
                </table>
                <p class="mt-3 mb-0" v-if="installments[0].tax > 0">
                    * Al primo importo si aggiungono <strong>€ {{ installments[0].tax }}</strong> per 
                    <span v-if="category == 'Corso di Laurea'">la Tassa Servizi allo Studente</span> 
                    <span v-else>spese di bollo</span>
                </p>
            </div>
            <div class="bg-light rounded text-secondary mx-3 mb-3 p-3" v-if="installments_next && category != 'Esami Singoli' && from != 'PEGASOINTERNATIONAL'">
                <p><strong><i class="fas fa-list-alt me-2"></i>PROSPETTO RATE EVENTUALI ANNI SUCCESSIVI</strong></p>
                <table class="table table-bordered table-sm text-secondary mb-0">
                    <thead>
                        <tr class="border-bottom">
                            <th>{{ $t('scadenza') }}</th>
                            <th class="text-center">{{ $t('importo') }}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(installment, index) in installments_next" :key="index" class="border-bottom"> 
                            <td>{{ installment.date }}</td> 
                            <td class="text-center" v-if="index == 0 && Number(installment.tax) > 0"><strong>€ {{ Number(installment.import) + Number(installment.tax) }}*</strong></td>
                            <td class="text-center" v-else><strong>€ {{ installment.import }}</strong></td>
                        </tr>
                    </tbody>
                </table>
                <p class="mt-3 mb-0" v-if="installments_next[0].tax > 0">
                    * Al primo importo si aggiungono <strong>€ {{ installments_next[0].tax }}</strong> per 
                    <span v-if="category == 'Corso di Laurea'">la Tassa Servizi allo Studente</span> 
                    <span v-else>spese di bollo</span>
                </p>
            </div>
            <div class="bg-light rounded text-secondary mx-3 mb-3 p-3" v-if="singles">
                <p><strong><i class="fas fa-list-alt me-2"></i>PROSPETTO</strong></p>
                <table class="table table-bordered table-sm text-secondary mb-0">
                    <thead>
                        <tr class="border-bottom">
                            <th class="text-center">CFU</th>
                            <th class="text-center">Costo/CFU</th>
                            <th class="text-center">Importo</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr class="border-bottom"> 
                            <td class="text-center">{{ singles.sumCfu }}</td> 
                            <td class="text-center">€ {{ singles.importCfu }}</td> 
                            <td class="text-center"><strong>€ {{ singles.import }}</strong></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div> 
</template>

<script>
    export default {
        computed: {
            university() {
                return this.$store.getters['settings/from'].name
            },
            from() {
                return this.$store.getters['settings/from'].crm
            },
            categorySettings() {
                return this.$store.getters['settings/category']
            },
            category() {
                return this.$store.getters['summary/category']
            },
            course() {
                return this.$store.getters['summary/course']
            },
            ecp() {
                return this.$store.getters['summary/ecp']
            },
            ecp_text() {
                return this.$store.getters['settings/from'].ecp_text
            },
            convention() {
                return this.$store.getters['summary/convention']
            },
            program() {
                return this.$store.getters['summary/program']
            },
            rate() {
                return this.$store.getters['summary/rate']
            },
            mp_tot() {
                return this.$store.getters['summary/mp_tot']
            },
            installments() {
                return this.$store.getters['summary/installments']
            },
            installments_next() {
                return this.$store.getters['summary/installments_next']
            },
            singles() {
                return this.$store.getters['summary/singles']
            },
            showConvention() {
                return this.category != '24 CFU'
            },
            showProgram() {
                return this.category != 'Esami Singoli' && this.category != '24 CFU'
            },
            showInstallments() {
                return this.category != 'Esami Singoli' && this.category != '24 CFU'
            }
        }
    }
</script>